$(document).ready(function () {
  position_brand_information();
  MegaMenuHover();

  $(window).on('resize', function () {
    position_brand_information();
  });

  $(document).on('click', '[data-accordion-trigger]', function (e) {
      e.preventDefault();

      var Collapsible = $(this).closest('[data-accordion-section]');

      var parentCollapsible = $(this).closest('[data-accordion]');
      var collapsibleInner = parentCollapsible.find('[data-accordion-content]');

      if ($(this).attr('aria-expanded') === 'false') {
          Collapsible.find('[data-accordion-trigger]').attr('aria-expanded', 'false');
          Collapsible.find('[data-accordion-content]').slideUp();

          $(this).attr('aria-expanded', 'true');
          collapsibleInner.slideDown();

      } else {
          $(this).attr('aria-expanded', 'false');
          collapsibleInner.slideUp();
      }
  });

  $(document).on('click', '[data-trigger-menu-drawer]', function (e) {
    $('.header__icon--menu').trigger("click");
  });
});

function position_brand_information() {
  if ($(window).width() < 769) {
    $('.footer').append($('.footer-block--brand_information'));
  } else {
    $('.footer__blocks-wrapper').prepend($('.footer-block--brand_information'));
  }
}

function MegaMenuHover(e) {
  $(".mega-menu__item").hover(function () {
    $(this).siblings().removeClass('open');
    $(this).addClass('open');
  });
}